import { render } from "./WinnersTeam.vue?vue&type=template&id=a987f9be&scoped=true"
import script from "./WinnersTeam.vue?vue&type=script&lang=js"
export * from "./WinnersTeam.vue?vue&type=script&lang=js"

import "./WinnersTeam.vue?vue&type=style&index=0&id=a987f9be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a987f9be"

export default script